<template>
  <el-card shadow="alway" class="crm-card-box" :body-style="{ padding: '0px' }">
    <el-row
      v-if="!isLoading"
      :class="coupon.status == 1 ? 'active' : 'inactive'"
      @click.native="handleCoupon"
    >
      <el-col :span="8" class="">
        <div
          class="crm-card-menu-img"
          :style="{
            'background-image': `
                linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 38%, rgba(255,255,255,1) 100%),
                url(${crm_public_path}${coupon.imageKey})`,
          }"
          :src="`${crm_public_path}${coupon.imageKey}`"
          :alt="coupon.name"
        />
      </el-col>
      <el-col :span="16" class="px-4">
        <div class="crm-card-entry-descript">
          <label class="crm-card-name text-1-line">{{ coupon.name }}</label>
          <label v-if="coupon.status == 1" class="crm-card-descript">{{ $t('components.coupon.create-at') }} {{ coupon.createDt }}</label>
          <label v-if="coupon.status == 2" class="crm-card-descript">{{ $t('components.coupon.redeem-at') }} {{ coupon.redeemDt }}</label>
          <label v-if="coupon.status == 3" class="crm-card-descript">{{ $t('components.coupon.expre-at') }} {{ coupon.expiredDt }}</label>
        </div>
        <div v-if="coupon.status == 1" class="crm-card-entry-point">
          <label class="crm-card-point">{{ $t('components.coupon.show') }}</label>
        </div>
      </el-col>
    </el-row>
    <el-skeleton v-else animated>
      <template #template>
        <el-row>
          <el-col :span="8">
            <el-skeleton-item
              variant="image"
              class="crm-card-menu-img-loading"
            />
          </el-col>
          <el-col :span="16" class="py-4">
            <div class="px-4">
              <el-skeleton-item variant="p" class="crm-card-name" style="width: 60%" />
              <div class="crm-card-descript">
                <el-skeleton-item variant="p" style="width: 30%" />
              </div>
            </div>
            <div class="crm-card-entry-point pt-1 px-4">
              <el-skeleton-item
                variant="p"
                style="width: 15%;"
              />
            </div>
          </el-col>
        </el-row>
      </template>
    </el-skeleton>
  </el-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    isLoading: Boolean,
    coupon: {
      type: Object,
    },
  },
  data() {
    return {
      crm_public_path: process.env.VUE_APP_S3_PUBLIC_PATH,
    };
  },
  methods: {
    handleCoupon() {
      if (this.coupon.status == 1) {
        this.setCouponDetail(this.coupon);
        this.redeemCoupon({
          promotionRefKey: this.couponDetail.promotionRefKey,
          branchUUID: this.branchInfo.branchUUID,
        });
      }
    },
    ...mapActions({
      redeemCoupon: "coupon/redeemCoupon",
      setCouponDetail: "coupon/setCouponDetail",
    }),
  },
  computed: {
    ...mapGetters({
      branchInfo: "branch/branchInfo",
      couponDetail: "coupon/couponDetail",
    }),
  },
};
</script>

<style scoped>
.crm-card-box {
  background: #ffffff;
  box-shadow: 0px 4px 14px rgba(106, 113, 128, 0.1);
  border-radius: 12px;
  border: none;
}

.crm-card-box .inactive {
  filter: grayscale(100%);
}

.crm-card-box .crm-card-menu-img {
  width: 100%;
  height: 112px;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center;
}

.crm-card-menu-img-loading {
  width: 100%;
  height: 112px;
}

.crm-card-entry-descript {
  padding: 16px 0;
}

.crm-card-entry-point {
  text-align: right;
  margin-right: 16px;
}

.crm-card-name {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: #333333;
}

.crm-card-descript {
  color: #828282;
  font-size: 16px;
  font-weight: lighter;
}

.crm-card-point {
  color: var(--primary);
  font-size: 20px;
  margin-left: 5px;
  margin-top: -3px;
  text-align: right;
}
</style>
